import React from 'react'
import { Button } from 'is24-corecss'
import { useNavigate } from 'react-router-dom'
import { v4 as uuid } from 'uuid'
import { FLOWS } from '../../../app/AppRouter'
import { FlowName } from '../../../@types/flow-types'

/**
 * Only used in local setup to show a list of all available flows.
 */
const FlowChooserPage: React.FC = () => {
  const navigate = useNavigate()
  return (
    <div className='padding-xl'>
      <h3>Flow Chooser Page MOCK</h3>

      <div className='grid grid-flex gutter-m'>
        {FLOWS.map((flow, index) => (
          <div className='grid-item one-whole' key={index}>
            <Button appearance='primary' onClick={() => navigate(flow.flowInformation.path)}>
              {flow.flowInformation.name.replaceAll('_', ' ').toUpperCase()}
            </Button>
            <Button
              appearance='secondary'
              onClick={() => navigate(`${flow.flowInformation.path}?isVermietetDeView=true`)}
            >
              {'isVermietetDeView'}
            </Button>
            <Button appearance='secondary' onClick={() => navigate(`${flow.flowInformation.path}?isMobileView=true`)}>
              {'isMobileView'}
            </Button>
            {flow.flowInformation.name === FlowName.PROPERTY_OWNER_APARTMENT_RENT && (
              <Button
                appearance='secondary'
                onClick={() => navigate(`${flow.flowInformation.path}/published-listing-apartment-rent-${uuid()}`)}
              >
                {'Published Listing'}
              </Button>
            )}
            {flow.flowInformation.name === FlowName.AGENT_APARTMENT_RENT && (
              <Button
                appearance='secondary'
                onClick={() =>
                  navigate(`${flow.flowInformation.path}/agent-published-listing-apartment-rent-${uuid()}`)
                }
              >
                {'Published Listing'}
              </Button>
            )}
            {flow.flowInformation.name === FlowName.PROPERTY_OWNER_HOUSE_SELL && (
              <Button
                appearance='secondary'
                onClick={() => navigate(`${flow.flowInformation.path}/published-listing-house-sell-${uuid()}`)}
              >
                {'Published Listing'}
              </Button>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}

export default FlowChooserPage
